// Enum for loan purposes
export enum LoanPurpose {
  BUSINESS_EXPANSION = 'business-expansion',
  EQUIPMENT_PURCHASE = 'equipment-purchase',
  PAY_INVOICES = 'pay-invoices',
  INFRASTRUCTURE_UPGRADES = 'infrastructure-upgrades',
  WORKING_CAPITAL = 'working-capital',
  OTHER = 'other',
}

// Map to get display labels for the enum values
export const loanPurposeLabels: Record<LoanPurpose, string> = {
  [LoanPurpose.BUSINESS_EXPANSION]: 'Business Expansion',
  [LoanPurpose.EQUIPMENT_PURCHASE]: 'Equipment Purchase',
  [LoanPurpose.PAY_INVOICES]: 'Pay Invoices',
  [LoanPurpose.INFRASTRUCTURE_UPGRADES]: 'Infrastructure Upgrades',
  [LoanPurpose.WORKING_CAPITAL]: 'Working Capital',
  [LoanPurpose.OTHER]: 'Other',
};

// For backward compatibility with existing code that expects the array format
export const loanPurpose = Object.entries(loanPurposeLabels).map(([value, label]) => ({
  value,
  label,
}))
// Enum for industry types
export enum IndustryType {
  SERVICE_SECTOR_FB = 'service-sector-fb',
  SERVICE_SECTOR_NON_FB = 'service-sector-non-fb',
  HEALTH_HUMAN_SERVICES = 'health-human-services',
  EDUCATION = 'education',
  IT_SERVICES = 'it-services',
  MEDIA = 'media',
  AGRICULTURE_FISHING_FOOD_PRODUCTION = 'agriculture-fishing-foodproduction',
  WHOLESALE_TRADER = 'wholesale-trader',
  RETAIL_TRADING = 'retail-trading',
  MANUFACTURING_HEAVY_INDUSTRIES = 'manufacturing-heavy-industries',
  MANUFACTURING_CONSUMER_RELATED = 'manufacturing-consumer-related',
  MANUFACTURING_COMPUTER_ELECTRONICS = 'manufacturing-computer-electronics',
  ENERGY_GENERATION_DISTRIBUTION = 'energy-generation-distribution',
  TRANSPORT_LOGISTICS = 'transport-logistics',
  RENEWABLE = 'renewable',
  BUILDING_CONSTRUCTION_PRIVATE = 'building-construction-private',
  BUILDING_CONSTRUCTION_PUBLIC = 'building-construction-public',
  OTHER = 'other',
}

// Map to get display labels for the enum values
export const industryTypeLabels: Record<IndustryType, string> = {
  [IndustryType.SERVICE_SECTOR_FB]: 'Service Sector – F&B',
  [IndustryType.SERVICE_SECTOR_NON_FB]: 'Service Sector – non-F&B',
  [IndustryType.HEALTH_HUMAN_SERVICES]: 'Health & Human Services',
  [IndustryType.EDUCATION]: 'Education',
  [IndustryType.IT_SERVICES]: 'IT services',
  [IndustryType.MEDIA]: 'Media',
  [IndustryType.AGRICULTURE_FISHING_FOOD_PRODUCTION]: 'Agriculture / Fishing / Food Production',
  [IndustryType.WHOLESALE_TRADER]: 'Wholesale Trader',
  [IndustryType.RETAIL_TRADING]: 'Retail Trading',
  [IndustryType.MANUFACTURING_HEAVY_INDUSTRIES]: 'Manufacturing – heavy industries',
  [IndustryType.MANUFACTURING_CONSUMER_RELATED]: 'Manufacturing – consumer related',
  [IndustryType.MANUFACTURING_COMPUTER_ELECTRONICS]: 'Manufacturing – computer & electronics',
  [IndustryType.ENERGY_GENERATION_DISTRIBUTION]: 'Energy – generation and distribution',
  [IndustryType.TRANSPORT_LOGISTICS]: 'Transport & Logistics',
  [IndustryType.RENEWABLE]: 'Renewable',
  [IndustryType.BUILDING_CONSTRUCTION_PRIVATE]: 'Building and Construction - Private Sector',
  [IndustryType.BUILDING_CONSTRUCTION_PUBLIC]: 'Building and Construction - Public Sector',
  [IndustryType.OTHER]: 'Other',
};

// For backward compatibility with existing code that expects the array format
export const industryType = Object.entries(industryTypeLabels).map(([value, label]) => ({
  value,
  label,
}))
